import React, { useState, useRef, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as NIHLogo } from "../assets/nih.svg";
import { ReactComponent as NSFLogo } from "../assets/NSF_logo.svg";

const AttributionBox = () => {
  const [expanded, setExpanded] = useState(false);
  const boxRef = useRef(null);

  const toggleExpanded = () => setExpanded((prev) => !prev);

  useEffect(() => {
    const handleClickOff = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    if (expanded) {
      document.addEventListener("mousedown", handleClickOff);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOff);
    };
  }, [expanded]);

  return (
    <Box
      ref={boxRef}
      onClick={toggleExpanded}
      sx={{
        position: "absolute",
        bottom:
          "calc(env(safe-area-inset-bottom, 0px) + var(--panel-horizontal-offset, var(--panel-left-offset, 20px)))",
        left:
          "calc(env(safe-area-inset-left, 0px) + var(--panel-horizontal-offset, var(--panel-left-offset, 20px)))",
        maxWidth: "var(--panel-width-standard, 250px)",
        backgroundColor: "var(--surface-bg, rgba(9, 12, 18, 0.62))",
        color: "#fff",
        px: 2,
        py: expanded ? 2 : 1,
        zIndex: 1000,
        overflow: "hidden",
        boxSizing: "border-box",
        borderRadius: "var(--radius-lg, 14px)",
        boxShadow: "var(--surface-shadow, 0 14px 34px rgba(0, 0, 0, 0.34))",
        backdropFilter:
          "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
        WebkitBackdropFilter:
          "blur(var(--surface-blur, 10px)) saturate(var(--surface-saturate, 120%))",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
    >
      {expanded && (
        <Box align="left" sx={{ mb: 1 }}>
          <Typography
            variant="overline"
            sx={{ opacity: 0.72, letterSpacing: "0.11em" }}
          >
            About
          </Typography>
          <Typography variant="caption" sx={{ p: 1 }}>
            Made in collaboration with the Innovative Genomics Institute and
            Lawrence Hall of Science at UC Berkeley.
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="caption" align="left" sx={{ mr: 1, opacity: 0.86 }}>
          Funding support from
        </Typography>
        <NIHLogo width="50px" />
        <NSFLogo width="35px" />
      </Box>
    </Box>
  );
};

export default AttributionBox;
